import { Option } from '@core/model/framework/Result/Option';

export type BankConnection = {
  connectionId: string;
  state: ConnectionStateEnum;
  lastSynchronizedAt: Option<string>;
  bankId: string;
};

export enum ConnectionStateEnum {
  VALID = 'valid',
  SCA = 'sca',
  DECOUPLED = 'decoupled',
  MORE_INFORMATION = 'moreInformation',
  ACTION_NEEDED = 'actionNeeded',
  ERROR = 'error',
  PASSWORD_EXPIRED = 'passwordExpired',
  VALIDATING = 'validating',
  WEBAUTH_REQUIRED = 'webauthRequired',
}
